import { TranslateService } from '@ngx-translate/core';
import { CellType, ColumnConfig } from '@shared/table';
import { FeedbackRow, FeedbacksTableRowActions, FeedbackStatusOption } from './feedbacks.abstraction';
import { FeedbackStatusCellComponent, FeedbacksUserCellComponent } from './table-cells';
import { FeedbackStatus } from '@root/pages/feedback';

export class FeedbacksUtility {
  static getColumnsConfig(translateService: TranslateService): ColumnConfig<FeedbackRow>[] {
    return [
      {
        name: 'fullName',
        header: translateService.instant('feedbacksPage.table.column.user'),
        cellType: CellType.Custom,
        customCell: { component: FeedbacksUserCellComponent },
      },
      {
        name: 'receivedAt',
        header: translateService.instant('feedbacksPage.table.column.date'),
        isInline: true,
        width: '200px',
        sortKey: 'receivedAt',
        displayedProperties: ['receivedAt'],
        cellType: CellType.DateTime,
      },
      {
        name: 'status',
        header: translateService.instant('feedbacksPage.table.column.status'),
        sortKey: 'status',
        cellType: CellType.Custom,
        width: '200px',
        customCell: { component: FeedbackStatusCellComponent },
      },
      {
        name: 'actions',
        header: translateService.instant('feedbacksPage.table.column.actions'),
        width: '1%',
        actions: [
          {
            icon: 'eye',
            name: FeedbacksTableRowActions.Open,
          },
          {
            icon: 'archive',
            name: FeedbacksTableRowActions.Archive,
            permissions: ['ArchiveFeedback'],
          },
        ],
        cellType: CellType.Actions,
      },
    ];
  }

  static getStatusOptions(translateService: TranslateService): FeedbackStatusOption[] {
    return [
      {
        value: null,
        label: translateService.instant('feedbacksPage.filter.status.placeholder'),
      },
      {
        value: FeedbackStatus.New,
        label: translateService.instant('feedbacksPage.filter.status.option.new'),
      },
      {
        value: FeedbackStatus.InProgress,
        label: translateService.instant('feedbacksPage.filter.status.option.inProgress'),
      },
      {
        value: FeedbackStatus.Processed,
        label: translateService.instant('feedbacksPage.filter.status.option.processed'),
      },
    ];
  }
}
